export const SET_CONTENT = 'socrates-online/content/SET_CONTENT';
export const SET_CONTENT_FOR_META_INFO =
  'socrates-online/content/SET_CONTENT_FOR_META_INFO';
export const CLEAR_CONTENT_FOR_META_INFO =
  'socrates-online/content/CLEAR_CONTENT_FOR_META_INFO';
export const SET_KEY_PERSONNEL = 'socrates-online/content/SET_KEY_PERSONNEL';
export const IS_UPDATING_KEY_PERSONNEL =
  'socrates-online/content/IS_UPDATING_KEY_PERSONNEL';
export const SET_PARTNERS = 'socrates-online/content/SET_PARTNERS';
export const IS_UPDATING_PARTNERS = 'socrates-online/content/IS_UPDATING_PARTNERS';
export const IS_FETCHING = 'socrates-online/content/IS_FETCHING';
export const IS_NEW_CONTENT_AN_ARTICLE =
  'socrates-online/content/IS_NEW_CONTENT_AN_ARTICLE';
export const SET_TEMPLATE_INFO = 'socrates-online/content/SET_TEMPLATE_INFO';
export const RESET = 'socrates-online/content/RESET';

const initialState = {
  types: {
    announcement: 'Announcement',
    page: 'Page',
    article: 'Blog Article',
    email: 'Email',
    document: 'Document',
    endorsement: 'Endorsement',
  },
  keyPersonnel: [],
  isUpdatingKeyPersonnel: false,
  isFetching: false,
  partners: [],
  isUpdatingPartners: false,
  resources: [],
  metaInfo: null,
  template: null,
};

/**
 * The content reducer
 * @param state
 * @param action
 * @returns {{}}
 */
export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_CONTENT:
      return {
        ...state,
        resources: {
          ...state.resources,
          [action.data.data.id]: {
            ...action.data,
          },
        },
      };
    case SET_CONTENT_FOR_META_INFO:
      return {
        ...state,
        metaInfo: action.data,
      };
    case IS_NEW_CONTENT_AN_ARTICLE:
      return {
        ...state,
        isNewContentAnArticle: action.data,
      };
    case SET_TEMPLATE_INFO:
      return {
        ...state,
        template: action.data,
      };
    case CLEAR_CONTENT_FOR_META_INFO:
      return {
        ...state,
        metaInfo: null,
      };
    case IS_UPDATING_KEY_PERSONNEL:
      return {
        ...state,
        isUpdatingKeyPersonnel: action.status,
      };
    case SET_KEY_PERSONNEL:
      return {
        ...state,
        keyPersonnel: action.data,
        isUpdatingKeyPersonnel: false,
      };
    case IS_UPDATING_PARTNERS:
      return {
        ...state,
        isUpdatingPartners: action.status,
      };
    case IS_FETCHING:
      return {
        ...state,
        isFetching: action.status,
      };
    case RESET:
      return {
        initialState,
      };
    case SET_PARTNERS:
      return {
        ...state,
        partners: action.data,
        isUpdatingPartners: false,
      };
    default:
      return state;
  }
}
